import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { HttpService } from './services/httpService';
import { StorageService } from './services/StorageService';
import { CryptoService } from './services/CryptoService';
import { PrivacyComponent } from './privacy/privacy.component';
import { TermsComponent } from './terms/terms.component';
import { ContactComponent } from './contact/contact.component';
import { BlogComponent } from './blog/blog.component';
import { CustomerSuccessStoriesComponent } from './customer-success-stories/customer-success-stories.component';
import { PricingComponent } from './pricing/pricing.component';
import { BrandAssetsComponent } from './brand-assets/brand-assets.component';
import { OurTeamAndMissionComponent } from './our-team-and-mission/our-team-and-mission.component';
import { SecurityComponent } from './security/security.component';
import { ResourcesComponent } from './resources/resources.component';
import { GuideComponent } from './guide/guide.component';
import { EachBlogComponent } from './each-blog/each-blog.component';
import { EachGuideComponent } from './each-guide/each-guide.component';
import { EachCustomerSuccessStoriesComponent } from './each-customer-success-stories/each-customer-success-stories.component';
import { ApiDocsComponent } from './api-docs/api-docs.component';
import { DownloadComponent } from './download/download.component';
import { RegisterComponent } from './register/register.component';
import { ReceiveComponent } from './receive/receive.component';
import { VerifyComponent } from './verify/verify.component';
import { VerifyBankConnectionComponent } from './verify-bank-connection/verify-bank-connection.component';
import { DepositVerifyComponent } from './deposit-verify/deposit-verify.component';
import { MicroDepositVerificationComponent } from './micro-deposit-verification/micro-deposit-verification.component';
import { BusinessUsesComponent } from './business-uses/business-uses.component';
import { PitchComponent } from './pitch/pitch.component';
import { InvestorMeetingsComponent } from './investor-meetings/investor-meetings.component';
import { DemoComponent } from './demo/demo.component';
import { WebIntegrationComponent } from './web-integration/web-integration.component';
import { WebIntegration1Component } from './web-integration-1/web-integration-1.component';
import { ConnectComponent } from './connect/connect.component';
import { PlatformComponent } from './platform/platform.component';
import { RestrictedComponent } from './restricted/restricted.component';
import { EsignComponent } from './esign/esign.component';
import { BankDebitAuthorizationComponent } from './bank-debit-authorization/bank-debit-authorization.component';
import { PaymentServicesAgreementComponent } from './payment-services-agreement/payment-services-agreement.component';
import { AchComponent } from './ach/ach.component';
import { RoiCalculatorComponent } from './roi-calculator/roi-calculator.component';
import { EnterpriseDecksComponent } from './enterprise-decks/enterprise-decks.component';
import { MeetWithComponent } from './meet-with/meet-with.component';
import { CabbageCardComponent } from './cabbage-card/cabbage-card.component';
import { WhiteLabelDemoComponent } from './white-label-demo/white-label-demo.component';
import { PayWithBankComponent } from './pay-with-bank/pay-with-bank.component';
import { RoiCalculatorV1Component } from './roi-calculator-v1/roi-calculator-v1.component';
import { NumberCommaDirective } from './number-comma.directive';
import { RoiCalculatorV2Component } from './roi-calculator-v2/roi-calculator-v2.component';
import { NewWebsiteTempComponent } from './new-website-temp/new-website-temp.component';
import { ProductionTokenComponent } from './production-token/production-token.component';
import { GridEndUserPrivacyPolicyComponent } from './grid-end-user-privacy-policy/grid-end-user-privacy-policy.component';
import { InvestorFaqComponent } from './investor-faq/investor-faq.component';
import { RoiCalculatorV3Component } from './roi-calculator-v3/roi-calculator-v3.component';
import { RoiCalculatorV4Component } from './roi-calculator-v4/roi-calculator-v4.component';
import { RoiCalculatorFinGridComponent } from './roi-calculator-fingrid/roi-calculator-fingrid.component';
import { RoiCalculatorV5Component } from './roi-calculator-v5/roi-calculator-v5.component';
import { GridEndUserTermsComponent } from './grid-end-user-terms/grid-end-user-terms.component';
import { WebsiteTermsComponent } from './website-terms/website-terms.component';
import { ScheduleComponent } from './schedule/schedule.component';

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    CounterComponent,
    FetchDataComponent,
    PrivacyComponent,
    TermsComponent,
    ContactComponent,
    BlogComponent,
    CustomerSuccessStoriesComponent,
    PricingComponent,
    BrandAssetsComponent,
    OurTeamAndMissionComponent,
    SecurityComponent,
    ResourcesComponent,
    GuideComponent,
    EachBlogComponent,
    EachGuideComponent,
    EachCustomerSuccessStoriesComponent,
    ApiDocsComponent,
    DownloadComponent,
    RegisterComponent,
    ReceiveComponent, 
    VerifyComponent,
    VerifyBankConnectionComponent,
    DepositVerifyComponent,
    BusinessUsesComponent,
    MicroDepositVerificationComponent,
    PitchComponent,
    InvestorMeetingsComponent,
    DemoComponent,
    WebIntegrationComponent,
    WebIntegration1Component,
    ConnectComponent,
    PlatformComponent,
    RestrictedComponent,
    EsignComponent,
    BankDebitAuthorizationComponent,
    PaymentServicesAgreementComponent,
    RoiCalculatorComponent,
    AchComponent,
    EnterpriseDecksComponent,
    MeetWithComponent,
    CabbageCardComponent,
    WhiteLabelDemoComponent,
    PayWithBankComponent,
    RoiCalculatorV1Component,
    NumberCommaDirective,
    RoiCalculatorV2Component,
    NewWebsiteTempComponent,
    ProductionTokenComponent,
    GridEndUserPrivacyPolicyComponent,
    InvestorFaqComponent,
    RoiCalculatorV3Component,
    RoiCalculatorV4Component,
    RoiCalculatorFinGridComponent,
    RoiCalculatorV5Component,
    GridEndUserTermsComponent,
    WebsiteTermsComponent,
    ScheduleComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    RouterModule.forRoot([
      { path: '', component: HomeComponent, pathMatch: 'full' },
      { path: 'pay/:id', component: CounterComponent },
      { path: 'instant-verify/:id', component: VerifyComponent },
      { path: 'deposit-verify/:id', component: DepositVerifyComponent },
      { path: 'verify-micro-deposits/:id', component: MicroDepositVerificationComponent },
      { path: 'verify-bank-connection/:id', component: VerifyBankConnectionComponent },
      { path: 'receive/:id', component: ReceiveComponent },
      { path: 'send/:id', component: FetchDataComponent },
      { path: 'blog/:id', component: EachBlogComponent },
      { path: 'blog', component: BlogComponent },
      { path: 'pricing', component: PricingComponent },
      { path: 'resources', component: ResourcesComponent },
      { path: 'guide', component: GuideComponent },
      { path: 'guide/:id', component: EachGuideComponent },
      { path: 'our-team-and-mission', component: OurTeamAndMissionComponent },
      { path: 'brand-assets', component: BrandAssetsComponent },
      { path: 'api-docs', component: ApiDocsComponent },
      { path: 'download', component: DownloadComponent },
      { path: 'apply-for-the-cabbage-card', component: CabbageCardComponent },
      { path: 'security', component: SecurityComponent },
      { path: 'customer-success-stories/:id', component: EachCustomerSuccessStoriesComponent },
      { path: 'customer-success-stories', component: CustomerSuccessStoriesComponent },
      { path: 'privacy-policy', component: PrivacyComponent },
      { path: 'register', component: RegisterComponent },
      { path: 'terms-of-service', component: TermsComponent },

      { path: 'roi-calculator/old', component: RoiCalculatorComponent },
      { path: 'roi-calculator', component: RoiCalculatorFinGridComponent },
      { path: 'roi-calculator/onedine', component: RoiCalculatorV1Component },
      { path: 'roi-calculator/zuppler', component: RoiCalculatorV3Component },
      { path: 'roi-calculator/lunchbox', component: RoiCalculatorV5Component },
      { path: 'roi-calculator/tabit', component: RoiCalculatorV4Component },
      { path: 'roi-calculator/cloud-waitress', component: RoiCalculatorV2Component },


      

      { path: 'new-website', component: NewWebsiteTempComponent },



      { path: 'why-cabbage-pay', component: EnterpriseDecksComponent },

      { path: 'why-cabbage-pay/:id', component: EnterpriseDecksComponent },
      { path: 'why-fingrid/:id/:owner', component: EnterpriseDecksComponent },

      
      { path: 'investor/faq', component: InvestorFaqComponent },



      { path: 'legal/terms-of-service', component: TermsComponent },
      { path: 'legal/ach', component: AchComponent },
      { path: 'legal/payment-services-agreement', component: PaymentServicesAgreementComponent },
      { path: 'legal/connected-account-agreement', component: ConnectComponent },
      { path: 'legal/connect-platform-agreement', component: PlatformComponent },
      { path: 'legal/restricted-businesses', component: RestrictedComponent },
      { path: 'legal/e-sign-disclosure', component: EsignComponent },
      { path: 'legal/privacy-policy', component: PrivacyComponent },
      { path: 'legal/bank-debit-authorizations', component: BankDebitAuthorizationComponent },
      { path: 'legal/website-terms', component: WebsiteTermsComponent },


      //end user
      { path: 'legal/end-user-pay-by-bank-privacy-policy', component: GridEndUserPrivacyPolicyComponent },
      { path: 'legal/end-user-pay-by-bank-terms', component: GridEndUserTermsComponent },


      

      { path: 'contact', component: ContactComponent },
      { path: 'schedule/:id', component: ScheduleComponent },













      { path: 'business-use', component: BusinessUsesComponent },
      { path: 'pitch', component: PitchComponent },
      { path: 'investor-meeting', component: InvestorMeetingsComponent },

      { path: 'meet-with/:id', component: MeetWithComponent },

      { path: 'demo/cabbage-checkout', component: DemoComponent },
      { path: 'demo/white-label/:id', component: WhiteLabelDemoComponent },


      { path: 'pay-with-bank', component: PayWithBankComponent },
      { path: 'checkout-demo', component: DemoComponent },
      { path: 'white-label-demo/:id', component: WhiteLabelDemoComponent },
      { path: 'production-token/:id', component: ProductionTokenComponent },
      { path: 'api-docs/get-started', component: WebIntegrationComponent },
      { path: 'api-docs/web-integration', component: WebIntegration1Component },
    ])
  ],
  providers: [HttpService, StorageService, CryptoService],
  bootstrap: [AppComponent]
})
export class AppModule { }
